import { SEARCHWORKSPACE_FAIL, SEARCHWORKSPACE_SUCCESS } from '../actionTypes';

const initialState = {
	user: null
};

const searchWorkspaceReducer = (state = initialState, action) => {
	switch (action.type) {
		case SEARCHWORKSPACE_SUCCESS:
			return {
				...state,
				isLoggedIn: true,
				user: action.payload.user,
			};
		case SEARCHWORKSPACE_FAIL:
			return {
				...state,
				isLoggedIn: false,
				user: null,
			};
		default:
			break;
	}

	return state;
};

export default searchWorkspaceReducer;
